module.exports = __webpack_public_path__ + "img/card_img_four.dec88130.png";